import {
    // Member Set
    doMemberSet,

    // Member Fetch
    initMemberFetch,
    requestMemberFetch,
    receiveMemberFetch,
    errorMemberFetch,
    finishMemberFetch,

    // Members fetch by company
    initMembersFetchByCompany,
    requestMembersFetchByCompany,
    receiveMembersFetchByCompany,
    errorMembersFetchByCompany,
    finishMembersFetchByCompany,

    // Member Insert
    initMemberInsert,
    requestMemberInsert,
    receiveMemberInsert,
    errorMemberInsert,
    finishMemberInsert,

    // Member Update
    initMemberUpdate,
    requestMemberUpdate,
    receiveMemberUpdate,
    errorMemberUpdate,
    finishMemberUpdate,

    // Member Address Update
    initMemberAddressUpdate,
    requestMemberAddressUpdate,
    receiveMemberAddressUpdate,
    errorMemberAddressUpdate,
    finishMemberAddressUpdate,
} from '../actions/memberActions';

import {
    fetchMember,
    fetchMembersByCompany,
    insertMember,
    updateMember,
    updateMemberAddressByPurpose,
} from '@general/api/memberAPI';

export const dispatchMemberSet = member => dispatch => {
    dispatch(doMemberSet(member));
};

export const dispatchMemberFetch = id => async dispatch => {
    dispatch(initMemberFetch());
    dispatch(requestMemberFetch());

    try {
        const memberData = await fetchMember(id);
        dispatch(receiveMemberFetch(memberData));
        return memberData;
    } catch (error) {
        dispatch(errorMemberFetch(error.message));
        throw new Error(error);
    } finally {
        dispatch(finishMemberFetch());
    }
};

export const dispatchMembersFetchByCompany = (companyID, companyToken) => async dispatch => {
    dispatch(initMembersFetchByCompany());
    dispatch(requestMembersFetchByCompany());

    try {
        const response = await fetchMembersByCompany(companyID, companyToken);
        const {
            data: { data },
        } = response;

        dispatch(receiveMembersFetchByCompany(data));
        return data;
    } catch (error) {
        dispatch(errorMembersFetchByCompany(error.message));
        throw new Error(error);
    } finally {
        dispatch(finishMembersFetchByCompany());
    }
};

// Member Insert
export const dispatchMemberInsert = (values, noLogin, companyToken) => async dispatch => {
    dispatch(initMemberInsert());
    dispatch(requestMemberInsert());

    try {
        const newMember = await insertMember(values, noLogin, companyToken);
        dispatch(receiveMemberInsert(newMember));
        return newMember;
    } catch (error) {
        if (error.response && error.response.data && error.response.data.errors) {
            dispatch(errorMemberInsert(error.response.data.errors.join('. ')));
            return;
        }

        dispatch(errorMemberInsert(error.message));
        throw new Error(error);
    } finally {
        dispatch(finishMemberInsert());
    }
};

// Member Update
export const dispatchMemberUpdate = (id, values, companyToken) => async dispatch => {
    dispatch(initMemberUpdate());
    dispatch(requestMemberUpdate());

    try {
        const updatedMember = await updateMember(id, values, companyToken);
        dispatch(receiveMemberUpdate(updatedMember));
        return updatedMember;
    } catch (error) {
        if (error.response && error.response.data && error.response.data.errors) {
            dispatch(errorMemberUpdate(error.response.data.errors.join('. ')));
            return;
        }

        dispatch(errorMemberUpdate(error.message));
        throw new Error(error);
    } finally {
        dispatch(finishMemberUpdate());
    }
};

// Member Address Update
export const dispatchMemberAddressUpdate = (memberID, purpose, addressData) => async dispatch => {
    dispatch(initMemberAddressUpdate());
    dispatch(requestMemberAddressUpdate());

    try {
        const response = await updateMemberAddressByPurpose(memberID, purpose, addressData);
        const {
            data: { data },
        } = response;

        dispatch(receiveMemberAddressUpdate(data));
        return data;
    } catch (error) {
        dispatch(errorMemberAddressUpdate(error.message));
        throw new Error(error);
    } finally {
        dispatch(finishMemberAddressUpdate());
    }
};
